import React, { useState } from 'react';
import TermsAndConditions from './TermsAndConditions'; // Импортируем новый компонент

const AlipayWechatForm = ({ handleSubmit, setCurrentView }) => {
    const [termsAccepted, setTermsAccepted] = useState(false);

    return (
        <div id="alipayWechatForm" className="form-container">
            <h2>Пополнить Alipay/Wechat</h2>
            <form onSubmit={(e) => handleSubmit(e, 'alipayWechat')}>
                <label htmlFor="alipayWechatAmountRub">Сумма обмена в рублях:</label>
                <input type="number" id="alipayWechatAmountRub" name="amountRub" required />

                <label htmlFor="alipayWechatBank">Банк, с которого оплачиваете:</label>
                <input type="text" id="alipayWechatBank" name="bank" required />

                <label htmlFor="alipayWechatSenderName">ФИО отправителя в банке:</label>
                <input type="text" id="alipayWechatSenderName" name="senderName" required />

                <label htmlFor="alipayWechatTelegram">Телеграм для связи:</label>
                <input type="text" id="alipayWechatTelegram" name="telegram" required />

                <TermsAndConditions
                    isChecked={termsAccepted}
                    onCheckboxChange={() => setTermsAccepted(!termsAccepted)}
                    onShowRules={() => setCurrentView('rules', 'alipayWechat')} // Передаем текущий view для возврата
                />
                <button type="submit" disabled={!termsAccepted}>Отправить заявку</button>
                <button type="button" onClick={() => { setCurrentView('mainMenu'); setTermsAccepted(false); }}>Назад в главное меню</button>
            </form>
        </div>
    );
};

export default AlipayWechatForm;